import React, { useEffect, useRef, useState } from "react";
import { ICommunityLayoutProps } from "./util";
import Slider from "react-slick";
import { BackgroundImage, WsrvImage } from "../Media";
import { EWsrvTransform, IAgent } from "../../lib";
import { ContactForm } from "../Forms/ContactForm";
import { MarketStats } from "../MarketStats/MarketStats";
import { FaChevronLeft, FaChevronRight, FaLongArrowAltDown, FaLongArrowAltUp } from "react-icons/fa";
import { EListingCardLayouts, ListingCard } from "../Listing";
import { Button } from "../Button/Button";
import { ContactCard } from "../Contact";
import { MapBlade } from "../Blades/MapBlade";

export const CommunityLayoutHeroBox: React.FC<ICommunityLayoutProps> = ({
    title,
    linkFunc,
    heroBackgroundImageUrl,
    heroCarouselImagesUrls,
    heroWrapperClassNames = "",
    heroBoxClassNames = "",
    communityFacts,
    description,
    requestInfoFormProps,
    markets,
    marketStatsProps,
    marketReportBgImageUrl,
    showMarketStats = true,
    communityAmenities,
    communityAmenitiesBgImageUrl,
    communityAmenitiesBgImageProps,
    communityStatistics,
    communityStatisticsBgImageUrl,
    communityStatisticsBgImageProps,
    listings,
    listingsSearchUrl,
    listingsResultCardsProps,
    listingsResultPageSize = 6,
    agents,
    agentsSearchUrl,
    agentsCardProps,
    location,
    mapBladeProps,
}) => {
    const amenitiesRef = useRef<any>(null)
    const statisticsRef = useRef<any>(null)
    const heroSliderRef = useRef<any>(null)
    const formWrapperRef = useRef<any>(null)
    const textWrapperRef = useRef<any>(null)
    let heroBox = (
        <div className={`absolute w-full lg:w-1/3 inset-x-0 bottom-0 lg:inset-y-0 lg:right-auto lg:left-0 inverted flex flex-col justify-evenly items-center py-5 lg:py-0 ${heroBoxClassNames}`}>
            {title && <h2>{title}</h2>}
            {communityFacts && communityFacts.length > 0 && (
                <div className="w-full flex flex-wrap">
                    {communityFacts.map((fact, factIndex) => (
                        <div key={factIndex} className={`w-1/2 py-2.5 px-4 xl:py-4 xl:px-5 flex flex-col ${factIndex % 2 == 0 ? "border-r" : ""}`}>
                            <div className="text-xs lg:text-sm text-center">{fact.title}</div>
                            <div className={`font-semibold text-center grow flex flex-col justify-center pt-1 xl:pt-2.5 lg:text-xl xl:text-3xl`} dangerouslySetInnerHTML={{ __html: fact.content ?? "" }}></div>
                            {factIndex < communityFacts.length - 2 && <div className="h-px w-full bg-body-text-inverted mt-2.5 xl:mt-4"></div>}
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
    let statWpprClass = ""
    if (!marketReportBgImageUrl) {
        statWpprClass = "md:border-b md:[&:nth-child(n+4)]:border-b-0 md:after:content-[''] md:after:inline-block md:after:w-px md:after:absolute md:after:inset-y-0 md:after:right-0 md:after:bg-body-text-inverted md:after:my-5 md:[&:nth-child(3n+3)::after]:hidden"
    }
    const marketStats = markets && (
        <MarketStats
            markets={markets}
            title={`${title} Market Summary`}
            className={`mx-auto min-h-screen !max-w-none !justify-evenly ${marketReportBgImageUrl ? "" : "inverted"}`}
            statsContainerClassName="mx-auto md:max-w-[90%]"
            statWrapperClassName={`relative w-full sm:!w-full md:!w-1/3 lg:!w-1/3 xl:!w-1/3 ${statWpprClass}`}
            statDividerClassName="!bg-body-text-inverted"
            {...marketStatsProps}
        />
    )
    const [displayedAgents, setDisplayedAgents] = useState<IAgent[]>([])
    const [isClient, setClient] = useState(false)
    useEffect(() => {
        if (agents) {
            if (agents.length > 3) {
                const allAgents = agents
                const agentsArray = []
                do {
                    const partnerItemIndex = Math.floor(Math.random() * allAgents.length)
                    agentsArray.push(allAgents[partnerItemIndex])
                    agents.splice(partnerItemIndex, 1)
                } while (agentsArray.length < 3)
                setDisplayedAgents(agentsArray)
            }
            else {
                setDisplayedAgents(agents)
            }
        }
        setClient(true)
    }, [])
    const [textColActualHeight, setTextTextColActualHeight] = useState(0)
    const [textColHeight, setTextColHeight] = useState<any>("auto")
    const [formHeight, setFormHeight] = useState(0)
    const [displayShowMore, setDisplayShowMore] = useState(false)
    const [isTextCollapsed, setIsTextCollapsed] = useState(false)
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 1024) {
                const vFormHeigh = (formWrapperRef.current.querySelector("ul.main-list")).clientHeight
                setFormHeight(vFormHeigh)
                setTextColHeight("auto")
                setTextTextColActualHeight(textWrapperRef.current.clientHeight)
                setTextColHeight(vFormHeigh)
                setDisplayShowMore(true)
                setIsTextCollapsed(true)
            }
            else {
                setTextColHeight("auto")
                setDisplayShowMore(false)
                setIsTextCollapsed(false)
            }
        }
        setTimeout(() => {
            if (window.innerWidth >= 1024) {
                const vFormHeigh = (formWrapperRef.current.querySelector("ul.main-list")).clientHeight
                setTextTextColActualHeight(textWrapperRef.current.clientHeight)
                setFormHeight(vFormHeigh)
                setTextColHeight(vFormHeigh)
                setDisplayShowMore(true)
                setIsTextCollapsed(true)
            }
        }, 500)
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [])
    const onShowMoreClick = () => {
        setTextColHeight(textColActualHeight)
        setIsTextCollapsed(false)
    }
    const onShowLessClick = () => {
        setTextColHeight(formHeight)
        setIsTextCollapsed(true)
    }
    return (
        <>
            <div className={`community-hero-section relative w-full h-screen flex flex-col justify-center ${heroWrapperClassNames}`}>
                {heroCarouselImagesUrls && heroCarouselImagesUrls.length > 0 && (
                    <Slider
                        ref={heroSliderRef}
                        className="w-full h-full"
                        dots={false}
                        arrows={false}
                    >
                        {heroCarouselImagesUrls.map((img, imgIndex) => (
                            <WsrvImage
                                key={imgIndex}
                                urlParams={{
                                    originURL: img,
                                    preset: EWsrvTransform.cover16x9,
                                }}
                                imgProps={{
                                    wrapperClassName: "block w-full"
                                }}
                                className="h-screen w-full object-cover"
                            />
                        ))}
                    </Slider>
                )}
                {heroBox}
                <a className="lg:left-1/3 text-5xl absolute top-[35%] lg:top-auto text-composite-text hover:!text-composite-text" onClick={() => { heroSliderRef.current?.slickPrev() }}><FaChevronLeft /></a>
                <a className="right-0 text-5xl absolute top-[35%] lg:top-auto text-composite-text hover:!text-composite-text cursor-pointer" onClick={() => { heroSliderRef.current?.slickNext() }}><FaChevronRight /></a>
            </div>
            <div className="community-description relative mx-auto mt-10 py-9 w-full max-w-screen-xl flex flex-row flex-wrap lg:flex-nowrap lg:divide-x-2">
                <div className="w-full lg:w-1/2 py-6 lg:pr-6">
                    <h2 className="text-center">About</h2>
                    <div
                        ref={textWrapperRef}
                        className="leading-7 tracking-widest lg:overflow-hidden"
                        style={{
                            height: textColHeight,
                            transition: "height 2s"
                        }}
                        dangerouslySetInnerHTML={{
                            __html: description ?? ""
                        }}>
                    </div>
                    {displayShowMore && (
                        <div className="border-t border-h1-text flex flex-col items-center">
                            {!isTextCollapsed && <a className="cursor-pointer text-h1-text" onClick={onShowLessClick}><FaLongArrowAltUp /></a>}
                            {isTextCollapsed && <a className="cursor-pointer text-h1-text" onClick={onShowMoreClick}><FaLongArrowAltDown /></a>}
                        </div>
                    )}
                </div>
                <div ref={formWrapperRef} className="w-full lg:w-1/2 py-6 lg:pl-6">
                    <ContactForm
                        title="Request Information"
                        classNames="strictTwoColumn"
                        inputTextAreaLabel="Add a message here..."
                        {...requestInfoFormProps}
                    >
                    </ContactForm>
                </div>
            </div >
            {showMarketStats && (
                <>
                    {marketStats && marketReportBgImageUrl && (
                        <div style={{ textShadow: "1px 1px 2px #3c3c3c" }}>
                            <BackgroundImage
                                src={marketReportBgImageUrl}
                                className="p-12 inverted"
                                sizesAndAspect={[
                                    {
                                        width: 420,
                                        aspect: EWsrvTransform.cover2x6,
                                    },
                                    {
                                        media: "min-width:420px",
                                        width: 640,
                                        aspect: EWsrvTransform.cover2x6,
                                    },
                                    {
                                        media: "min-width:640px",
                                        width: 768,
                                        aspect: EWsrvTransform.cover3x2,
                                    },
                                    {
                                        media: "min-width:768px",
                                        width: 1024,
                                        aspect: EWsrvTransform.cover3x2,
                                    },
                                    {
                                        media: "min-width:1024px",
                                        width: 1280,
                                        aspect: EWsrvTransform.cover16x9,
                                    },
                                    {
                                        media: "min-width:1280px",
                                        width: 1440,
                                        aspect: EWsrvTransform.cover16x9,
                                    },
                                ]}
                            >
                                {marketStats}
                            </BackgroundImage>
                        </div>
                    )}
                    {marketStats &&
                        !marketReportBgImageUrl &&
                        marketStats}
                </>
            )
            }
            {communityAmenities?.[0] && communityAmenitiesBgImageUrl && (
                <BackgroundImage
                    className="community-amenities-bg min-h-screen flex flex-col items-end"
                    src={communityAmenitiesBgImageUrl}
                    {...communityAmenitiesBgImageProps}
                >
                    <div className="grow w-full lg:w-1/3 p-5 lg:pr-16 lg:pl-2.5 bg-gradient-to-l from-black/90 to-transparent text-composite-text flex flex-col justify-center">
                        <h2 className="text-composite-text text-center mb-7">Amenities</h2>
                        <Slider
                            ref={amenitiesRef}
                            className="w-full"
                            arrows={false}
                            dots={false}
                            infinite={true}
                            slidesToShow={1}
                            slidesToScroll={1}
                        >
                            {communityAmenities.map((amenity, amenityIndex) => (
                                <div key={amenityIndex} className="!flex !flex-col w-full gap-y-3">
                                    <div className="flex justify-between items-center">
                                        <a className="text-composite-text hover:!text-composite-text" onClick={() => { amenitiesRef.current?.slickPrev() }}><FaChevronLeft /></a>
                                        <h3 className="text-composite-text text-center">{amenity.title}</h3>
                                        <a className="text-composite-text hover:!text-composite-text cursor-pointer" onClick={() => { amenitiesRef.current?.slickNext() }}><FaChevronRight /></a>
                                    </div>
                                    <div className="border-t border-composite-text py-4 px-1" dangerouslySetInnerHTML={{ __html: amenity.content ?? "" }}></div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </BackgroundImage>
            )}
            {location && (
                <MapBlade
                    title="Community Map"
                    titleHeadingLevel="h2"
                    className="mx-auto py-7 md:px-7 !justify-start"
                    locations={[{ address: {}, location: location }]}
                    mapProps={{
                        mapContainerClassName: "h-[65vh] w-full md:w-[90%]",
                    }}
                    mapWrapperProps={{
                        useSimpleMarker: true
                    }}
                    {...mapBladeProps}
                >
                </MapBlade>
            )}
            {communityStatistics?.[0] && communityStatisticsBgImageUrl && (
                <BackgroundImage
                    className="community-statistics-bg min-h-screen flex flex-col items-start"
                    src={communityStatisticsBgImageUrl}
                    {...communityStatisticsBgImageProps}
                >
                    <div className="grow w-full lg:w-1/3 p-5 lg:pl-16 lg:pr-2.5 bg-gradient-to-r from-black/90 to-transparent text-composite-text flex flex-col justify-center">
                        <h2 className="text-composite-text text-center mb-7">Community Statistics</h2>
                        <Slider
                            ref={statisticsRef}
                            className="w-full"
                            arrows={false}
                            dots={false}
                            infinite={true}
                            slidesToShow={1}
                            slidesToScroll={1}
                        >
                            {communityStatistics.map((statistic, statisticIndex) => (
                                <div key={statisticIndex} className="!flex !flex-col w-full gap-y-3">
                                    <div className="flex justify-between items-center">
                                        <a className="text-composite-text hover:!text-composite-text" onClick={() => { statisticsRef.current?.slickPrev() }}><FaChevronLeft /></a>
                                        <h3 className="text-composite-text text-center">{statistic.title}</h3>
                                        <a className="text-composite-text hover:!text-composite-text cursor-pointer" onClick={() => { statisticsRef.current?.slickNext() }}><FaChevronRight /></a>
                                    </div>
                                    <div className="border-t border-composite-text py-4 px-1" dangerouslySetInnerHTML={{ __html: statistic.content ?? "" }}></div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </BackgroundImage>
            )}
            {listings?.[0] && (
                <div className="community-listings w-full max-w-screen-xl mx-auto flex flex-col items-center pb-4">
                    <h2 className="text-center pt-4 pb-6">New Listings <span className="block">{title}</span></h2>
                    <div className="w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-x-7 gap-y-2.5 px-3.5 py-3.5">
                        {listings.slice(0, listingsResultPageSize).map((listing, listingIndex) => (
                            <ListingCard
                                key={listingIndex}
                                keyIndex={listingIndex}
                                listing={listing}
                                layout={EListingCardLayouts.vertical}
                                linkFunc={linkFunc}
                                {...listingsResultCardsProps}
                            />
                        ))}
                    </div>
                    {listingsSearchUrl && (
                        <Button
                            line={true}
                            icon={false}
                            linkProps={{
                                href: listingsSearchUrl,
                                className: `normal-case italic font-normal`,
                            }}
                            linkFunc={linkFunc}
                        >
                            View All {listings.length} Results
                        </Button>
                    )}
                </div>
            )}
            {isClient && displayedAgents?.[0] && (
                <div className="community-agents w-full max-w-screen-lg mx-auto flex flex-col items-center">
                    <div className="w-full grid grid-cols-1 lg:grid-cols-3 gap-x-2.5 gap-y-4 px-3.5 pt-6">
                        {displayedAgents.map((agent, agentIndex) => (
                            <ContactCard
                                contact={agent}
                                key={agentIndex}
                                imageWsrvTransform={EWsrvTransform.thumb3x4}
                                linkFunc={linkFunc}
                                {...agentsCardProps}
                            />
                        ))}
                    </div>
                    {agentsSearchUrl && (
                        <Button
                            line={true}
                            icon={false}
                            linkProps={{
                                href: agentsSearchUrl,
                                className: `normal-case italic font-normal mt-4`,
                            }}
                            linkFunc={linkFunc}
                        >
                            View All {title} Agents
                        </Button>
                    )}
                </div>
            )}
        </>
    )
}

export default CommunityLayoutHeroBox